<script setup lang="ts">
import {PrimitiveProps} from 'radix-vue'
import {HTMLAttributes} from "vue";

const props = defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div :class="props.class">
    <slot />
  </div>
</template>
